import PasswordVisibility from '@stimulus-components/password-visibility'

export default class extends PasswordVisibility {
  toggle(event) {
    super.toggle(event)
    this.inputTarget.focus()
  }
}
